import Relationship from '@/types/Relationship'

export const relationshipOther: Relationship = {
  key: 'other',
  label: 'その他'
}

const items: Relationship[] = [
  {
    key: 'mother',
    label: 'お母さん'
  },
  {
    key: 'father',
    label: 'お父さん'
  },
  {
    key: 'sibling',
    label: '兄弟'
  },
  {
    key: 'grandparent',
    label: '祖父母'
  },
  {
    key: 'babysitter',
    label: 'ベビーシッター'
  },
  {
    key: 'childminder',
    label: '保育士'
  },
  {
    key: 'friend',
    label: '保護者の友人'
  },
  relationshipOther,
]
export default items

export const findRelationshipByKey = (key: string): Relationship => {
  return items.find(o => o.key === key) || relationshipOther
}
